
// src/components/GlobalNotification.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNotification } from "../context/NotificationContext";
import { useNavigate } from "react-router-dom";

const GlobalNotification = () => {
  const [globalNotification, setGlobalNotification] = useState(null);
  const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(true);
  
  // Use your custom hook to get notifications
  // const { notification } = useNotification();
  const navigate = useNavigate();
  const { notification, playNotificationSound } = useNotification();

  // Fetch notifications on initial load
  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setLoading(false);
          return; // Don't fetch if not logged in
        }
        
        const res = await axios.get("/api/notifications", {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        if (res.data && res.data.length > 0) {
          // Filter for active notifications
          const activeNotifications = res.data.filter(note => note.active !== false);
          
          if (activeNotifications.length > 0) {
            // Use the most recent notification
            setGlobalNotification(activeNotifications[0]);
            setVisible(true);
          }
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  // Update when new context notifications come in
  useEffect(() => {
    if (notification) {

      // Play sound whenever a new notification arrives
      playNotificationSound();

      // Create a properly formatted notification object from the socket data
      const formattedNotification = {
        _id: notification._id || `temp-${Date.now()}`, // Use actual ID or create temporary one
        message: notification.message || (typeof notification === 'string' ? notification : ''),
        type: notification.type || 'info',
        link: notification.link || null,
      };
      
      setGlobalNotification(formattedNotification);
      setVisible(true);
    }
  }, [notification, playNotificationSound]);

  // Handle disabling the notification
  const disableNotification = async (e) => {
    e.stopPropagation(); // Prevent click from bubbling to the parent
    if (!globalNotification) return;
    
    setVisible(false); // Hide immediately for better UX
    
    try {
      const token = localStorage.getItem("token");
      
      // Only call the API if it's a real notification with an ID
      // Skip for temporary notifications (from sockets without proper IDs)
      if (globalNotification._id && !globalNotification._id.startsWith('temp-')) {
        await axios.put(
          `/api/notifications/${globalNotification._id}`, 
          { active: false },
          { headers: { Authorization: `Bearer ${token}` }}
        );
      }
    } catch (err) {
      console.error("Error disabling notification:", err);
      // Even if there's an error, we keep it hidden for the current session
    }
  };

  // Handle clicking on the notification
  const handleNotificationClick = async () => {
    // Navigate to the notifications page
    navigate("/notifications");
    
    // Also disable this notification (optional - depends on your UX preference)
    if (globalNotification && globalNotification._id) {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        
        if (!globalNotification._id.startsWith('temp-')) {
          await axios.put(
            `/api/notifications/${globalNotification._id}`, 
            { active: false, isRead: true },
            { headers: { Authorization: `Bearer ${token}` }}
          );
        }
        
        setVisible(false);
      } catch (err) {
        console.error("Error marking notification as read:", err);
      }
    }
  };

  if (loading || !globalNotification || !visible) return null;

  return (
    <div 
      className="w-full bg-gray-900 text-white px-6 py-4 flex items-center justify-between cursor-pointer hover:bg-gray-800 transition-colors duration-200"
      onClick={handleNotificationClick}
    >
      <div className="flex items-center">
        {/* Notification icon */}
        <div className="mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </div>
        
        {/* Message with click hint */}
        <span className="text-lg flex items-center">
          {globalNotification.message}
          <span className="ml-2 text-sm text-gray-400">(Click to view all notifications)</span>
        </span>
      </div>
      
      <button
        onClick={disableNotification}
        className="text-gray-400 hover:text-gray-200 focus:outline-none text-2xl bg-transparent border-0 p-0 flex items-center justify-center h-8 w-8 rounded-full hover:bg-gray-700"
        aria-label="Dismiss notification"
      >
        &times;
      </button>
    </div>
  );
};

export default GlobalNotification;










// // live notification with websocket bt not linked to notification ooage
// // src/components/GlobalNotification.js
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNotification } from "../context/NotificationContext";

// const GlobalNotification = () => {
//   const [globalNotification, setGlobalNotification] = useState(null);
//   const [visible, setVisible] = useState(true);
//   const [loading, setLoading] = useState(true);
  
//   // Use your custom hook to get notifications
//   const { notification } = useNotification();

//   console.log('GLOBAL: Current notification from context:', notification);
//   console.log('GLOBAL: Current globalNotification state:', globalNotification);


//   // Fetch notifications on initial load
//   useEffect(() => {
//     console.log('GLOBAL: Initial fetch effect running');
//     const fetchNotifications = async () => {
//       setLoading(true);
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) {
//           setLoading(false);
//           return; // Don't fetch if not logged in
//         }
        
//         const res = await axios.get("/api/notifications", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
        
//         if (res.data && res.data.length > 0) {
//           // Filter for active notifications
//           const activeNotifications = res.data.filter(note => note.active !== false);
          
//           if (activeNotifications.length > 0) {
//             // Use the most recent notification
//             setGlobalNotification(activeNotifications[0]);
//             setVisible(true);
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNotifications();
//   }, []);

//   // Update when new context notifications come in
//   useEffect(() => {
//     if (notification) {
//       console.log("Received live notification:", notification);
      
//       // Create a properly formatted notification object from the socket data
//       const formattedNotification = {
//         _id: notification._id || `temp-${Date.now()}`, // Use actual ID or create temporary one
//         message: notification.message || (typeof notification === 'string' ? notification : ''),
//         type: notification.type || 'info',
//         link: notification.link || null,
//         // Add any other properties your notifications use
//       };
      
//       setGlobalNotification(formattedNotification);
//       setVisible(true);
//     }
//   }, [notification]);


//    // Watch for changes to the notification from context
//    useEffect(() => {
//     console.log('GLOBAL: notification dependency effect running with:', notification);
//     if (notification) {
//       console.log('GLOBAL: Setting globalNotification to:', notification);
//       setGlobalNotification(notification);
//       setVisible(true);
//     }
//   }, [notification]);

//   // Handle disabling the notification
//   const disableNotification = async () => {
//     if (!globalNotification) return;
    
//     setVisible(false); // Hide immediately for better UX
    
//     try {
//       const token = localStorage.getItem("token");
      
//       // Only call the API if it's a real notification with an ID
//       // Skip for temporary notifications (from sockets without proper IDs)
//       if (globalNotification._id && !globalNotification._id.startsWith('temp-')) {
//         await axios.put(
//           `/api/notifications/${globalNotification._id}`, 
//           { active: false },
//           { headers: { Authorization: `Bearer ${token}` }}
//         );
        
//         console.log("Notification disabled");
//       }
//     } catch (err) {
//       console.error("Error disabling notification:", err);
//       // Even if there's an error, we keep it hidden for the current session
//     }
//   };

//   if (loading || !globalNotification || !visible) return null;

//   return (
//     <div className="w-full bg-gray-900 text-white px-6 py-4 flex items-center justify-between">
//       <span className="text-lg">{globalNotification.message}</span>
//       <button
//         onClick={disableNotification}
//         className="text-gray-400 hover:text-gray-200 focus:outline-none text-2xl"
//         aria-label="Disable notification"
//       >
//         &times;
//       </button>
//     </div>
//   );
// };

// export default GlobalNotification;

















// // before live websocket
// // src/components/GlobalNotification.js
// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const GlobalNotification = () => {
//   const [notification, setNotification] = useState(null);
//   const [visible, setVisible] = useState(true);
//   const [loading, setLoading] = useState(true);

//   // Fetch notifications
//   useEffect(() => {
//     const fetchNotifications = async () => {
//       setLoading(true);
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) {
//           setLoading(false);
//           return; // Don't fetch if not logged in
//         }
        
//         const res = await axios.get("/api/notifications", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
        
//         if (res.data && res.data.length > 0) {
//           // Filter for active notifications
//           const activeNotifications = res.data.filter(note => note.active !== false);
          
//           if (activeNotifications.length > 0) {
//             // Use the most recent notification
//             setNotification(activeNotifications[0]);
//             setVisible(true);
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNotifications();
//   }, []);

//   // Handle disabling the notification
//   const disableNotification = async () => {
//     if (!notification) return;
    
//     setVisible(false); // Hide immediately for better UX
    
//     try {
//       const token = localStorage.getItem("token");
      
//       // Call the endpoint to disable the notification
//       await axios.put(
//         `/api/notifications/${notification._id}`, 
//         { active: false },
//         { headers: { Authorization: `Bearer ${token}` }}
//       );
      
//       console.log("Notification disabled");
//     } catch (err) {
//       console.error("Error disabling notification:", err);
//       // Even if there's an error, we keep it hidden for the current session
//     }
//   };

//   if (loading || !notification || !visible) return null;

//   return (
//     <div className="w-full bg-gray-900 text-white px-6 py-4 flex items-center justify-between">
//       <span className="text-lg">{notification.message}</span>
//       <button
//         onClick={disableNotification}
//         className="text-gray-400 hover:text-gray-200 focus:outline-none text-2xl"
//         aria-label="Disable notification"
//       >
//         &times;
//       </button>
//     </div>
//   );
// };

// export default GlobalNotification;